import { t } from "@/i18n-js/instance";
import { useUpgradePlanContext } from "../UpgradePlanContext";
import { LineItem } from "./LineItem";
import {
  getAmountWithCurrency,
  getDiscountPercentage,
  getDisplayIntervalText,
} from "./helpers";

export const PlanLineItems = () => {
  const { plan, emailHubPlan, isEmailHubRequired, isDoubleUpgrade } =
    useUpgradePlanContext();

  const featuresToDisplay =
    plan?.main_features || emailHubPlan?.main_features || [];

  const displayIntervalText = getDisplayIntervalText(plan);
  const amountWithCurrency = getAmountWithCurrency(plan);
  const discountPercentage = getDiscountPercentage(plan);

  return (
    <div className="border-primary rounded-lg border p-5">
      {plan && (
        <LineItem
          displayName={t(["pricing_plans.upgrade_modal", "plan_name"], {
            plan: plan.display_name,
          })}
          discountPercentage={discountPercentage}
          amountWithCurrency={amountWithCurrency}
          displayIntervalText={displayIntervalText}
          description={t([
            "pricing_plans.upgrade_modal",
            `${plan.tier || "default"}_description`,
          ])}
          isFirstLineItem={isEmailHubRequired}
          featuresToDisplay={featuresToDisplay}
          isDoubleUpgrade={isDoubleUpgrade}
        />
      )}

      {isEmailHubRequired && emailHubPlan && (
        <LineItem
          displayName={t(
            ["pricing_plans.upgrade_modal", "email_hub_plan_name"],
            {
              plan: emailHubPlan.display_name,
            },
          )}
          amountWithCurrency={emailHubPlan.amount_without_currency || ""}
          displayIntervalText={emailHubPlan.interval_abbreviation || ""}
          description={t([
            "pricing_plans.upgrade_modal",
            "email_hub_description",
          ])}
          mhMaximumTierUsage={emailHubPlan.current_tier_up_to}
          mhCurrentUsage={emailHubPlan.contact_count}
          isDoubleUpgrade={isDoubleUpgrade}
          isFreeTier={emailHubPlan.is_free_tier}
        />
      )}
    </div>
  );
};
